import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../services/api";
import InputMask from "react-input-mask";
import Swal from "sweetalert2";
import Menu from '../../comum/Menu/menu.jsx';
import Footer from '../../comum/Footer';

function CriarUsuario() {
  const navigate = useNavigate();
  const [cpf, setCpf] = useState("");
  const [usuario, setUsuario] = useState(null);
  const [dataNascimento, setDataNascimento] = useState("");
  const [senha, setSenha] = useState("");
  const [etapa, setEtapa] = useState(1);

  // Controle validação extra random
  const [campoValidacao, setCampoValidacao] = useState(null); // nome do campo a validar
  const [opcoesCampo, setOpcoesCampo] = useState([]); // opções para select (bairro, ufrg)
  const [respostaCampo, setRespostaCampo] = useState(""); // resposta digitada ou selecionada

  // Função para limpar formulário e reiniciar
  const limpar = () => {
    setCpf("");
    setUsuario(null);
    setDataNascimento("");
    setSenha("");
    setEtapa(1);
    setCampoValidacao(null);
    setOpcoesCampo([]);
    setRespostaCampo("");
  };

  // Remove tudo que não for dígito
  const somenteNumeros = (str) => str.replace(/\D/g, "");

  // Buscar usuário pelo CPF
  const buscarUsuario = async () => {
    const cpfLimpo = somenteNumeros(cpf);
    if (cpfLimpo.length !== 11) {
      Swal.fire("Erro", "CPF inválido", "error");
      return;
    }
    try {
      const { data } = await api.get(`/usuario/dados/000000?cpf=${cpfLimpo}`);
      if (data && data.length > 0) {
        const user = data[0];
        console.log("Resposta do backend:", data);
        // Valida admissão < 7 dias
        const dataAdmissao = new Date(user.dataadmissao);
        console.log('dataAdmissao: '+dataAdmissao);
        const hoje = new Date();
        console.log('Hoje: '+hoje);
        const hojeSemHoras = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate());
        console.log('hojeSemHoras: '+hojeSemHoras);
        const admissaoSemHoras = new Date(dataAdmissao.getFullYear(), dataAdmissao.getMonth(), dataAdmissao.getDate());
        console.log('admissaoSemHoras: '+hojeSemHoras);
        const diffDias = (hojeSemHoras - admissaoSemHoras) / (1000 * 60 * 60 * 24);
        console.log('Dias: '+diffDias);
        if (diffDias > 15) {
          Swal.fire("Atenção", "Data de admissão é maior que a data de Integração. Fazer o cadastro no aplicativo ARBOR.", "warning");
          return;
        }

        setUsuario(user);
        setEtapa(2);
      } else {
        Swal.fire("Erro", "CPF não encontrado", "error");
      }
    } catch (error) {
      Swal.fire("Erro", "Falha ao buscar usuário", "error");
    }
  };

  // Valida nascimento digitado vs API
  const validarNascimento = () => {
    if (!usuario) return;
    const nascimentoAPI = new Date(usuario.dtnascimento).toISOString().substring(0, 10);
    const nascimentoDigitado = new Date(dataNascimento).toISOString().substring(0, 10);
    if (nascimentoAPI === nascimentoDigitado) {
      gerarValidacaoExtra(usuario);
    } else {
      Swal.fire("Erro", "Data de nascimento incorreta", "error");
    }
  };

  // Gera campo extra randomizado para validação
  const gerarValidacaoExtra = (user) => {
    // Campos possíveis: datanascimento (já validado), RG (números), bairro, cep (números), email, ufrg
    const campos = ["rg", "bairro", "cep", "email", "ufrg"];
    const escolhido = campos[Math.floor(Math.random() * campos.length)];

    let opcoes = [];
    setRespostaCampo("");

    switch (escolhido) {
      case "bairro":
        {
          // Fictícios - garantir que não tenha o bairro real
          const bairrosFicticios = [
            "VILA", "SANTO AGOSTINHO", "VILA MARIA", "CENTRO",
            "TRÊS POÇOS", "PARAÍSO", "PRAÇA DA CONCORDIA",
            "ROLAMÃO", "9 DE ABRIL", "BOA VISTA", "ANO BOM", "MANEJO"
          ].filter(b => b.toUpperCase() !== user.bairro.toUpperCase());
          opcoes = shuffleArray([user.bairro, ...bairrosFicticios.slice(0, 4)]);
          setOpcoesCampo(opcoes);
        }
        break;
      case "ufrg":
        {
          const ufs = ["MG", "ES", "SP", "PR", "RS"].filter(uf => uf !== user.ufrg);
          opcoes = shuffleArray([user.ufrg, ...ufs.slice(0, 4)]);
          setOpcoesCampo(opcoes);
        }
        break;
      case "rg":
      case "cep":
      case "email":
        setOpcoesCampo([]); // campo digitado
        break;
      default:
        setOpcoesCampo([]);
        break;
    }

    setCampoValidacao(escolhido);
    setEtapa(3);
  };

  // Shuffle array simples
  const shuffleArray = (array) => array.sort(() => Math.random() - 0.5);

  // Verifica resposta do campo randomizado
  const validarCampoExtra = () => {
    if (!usuario || !campoValidacao) return;

    let valorCorreto = "";

    switch (campoValidacao) {
      case "rg":
        // Só números do RG para comparar
        valorCorreto = somenteNumeros(usuario.rg);
        if (somenteNumeros(respostaCampo) === valorCorreto) {
          setEtapa(4);
        } else {
          erroValidacao();
        }
        break;

      case "cep":
        valorCorreto = somenteNumeros(usuario.cep);
        if (somenteNumeros(respostaCampo) === valorCorreto) {
          setEtapa(4);
        } else {
          erroValidacao();
        }
        break;

      case "email":
        valorCorreto = usuario.email.trim().toLowerCase();
        if (respostaCampo.trim().toLowerCase() === valorCorreto) {
          setEtapa(4);
        } else {
          erroValidacao();
        }
        break;

      case "bairro":
      case "ufrg":
        // respostaCampo já é o valor selecionado
        if (respostaCampo === usuario[campoValidacao]) {
          setEtapa(4);
        } else {
          erroValidacao();
        }
        break;

      default:
        erroValidacao();
        break;
    }
  };

  // Função para erro de validação, volta para etapa 1 com mensagem
  const erroValidacao = () => {
    Swal.fire("Erro", "Validação não concluída, dados não conferem", "error");
    limpar();
  };

  // Salvar senha no backend
  const salvarSenha = async () => {
    try {
      const body = { senha };
      const response = await api.post(`/usuario/${usuario.chapa}`, body);

      if (response.status === 201) {
        localStorage.setItem("chapa", usuario.chapa);
        navigate("/arbor/usuario/validar");
      } else {
        Swal.fire("Erro", response.data?.erro || "Erro desconhecido", "error");
      }

    } catch (error) {
      if (error.response && error.response.status === 406) {
        const erroMsg = error.response.data?.erro || "Erro não especificado";
        Swal.fire("Erro", erroMsg, "error");
      } else {
        Swal.fire("Erro", "Falha ao salvar senha", "error");
      }
    }
  };

  return (
    <div className="d-flex flex-column min-vh-100">
      <Menu modulo="NOVO" />

      <div className="flex-grow-1 d-flex align-items-center justify-content-center">
        <div className="container p-4 shadow-sm bg-light rounded" style={{ maxWidth: 500 }}>
          <h4 className="mb-4 text-center">Criação de Usuário</h4>

          {/* Etapa 1 - CPF */}
          {etapa === 1 && (
            <>
              <label>CPF:</label>
              <InputMask
                mask="999.999.999-99"
                className="form-control"
                value={cpf}
                onChange={(e) => setCpf(e.target.value)}
              />
              <button className="btn btn-primary mt-3 w-100" onClick={buscarUsuario}>Buscar</button>
            </>
          )}

          {/* Etapa 2 - Data nascimento */}
          {etapa === 2 && usuario && (
            <>
              <p><strong>Nome:</strong> {usuario.nome}</p>
              <label>Data de nascimento:</label>
              <input
                type="date"
                className="form-control"
                value={dataNascimento}
                onChange={(e) => setDataNascimento(e.target.value)}
              />
              <button className="btn btn-success mt-3 w-100" onClick={validarNascimento}>Confirmar</button>
            </>
          )}

          {/* Etapa 3 - Validação extra randomizada */}
          {etapa === 3 && campoValidacao && (
            <>
              <label>
                Confirme seu {campoValidacao.toUpperCase()}:
              </label>

              {/* Se campo select (bairro, ufrg) */}
              {(campoValidacao === "bairro" || campoValidacao === "ufrg") ? (
                <select
                  className="form-control"
                  value={respostaCampo}
                  onChange={(e) => setRespostaCampo(e.target.value)}
                >
                  <option value="">Selecione</option>
                  {opcoesCampo.map((op, idx) => (
                    <option key={idx} value={op}>{op}</option>
                  ))}
                </select>
              ) : (
                // Campo digitado (rg, cep, email)
                <input
                  type={campoValidacao === "email" ? "email" : "text"}
                  className="form-control"
                  value={respostaCampo}
                  onChange={(e) => setRespostaCampo(e.target.value)}
                />
              )}

              <button className="btn btn-success mt-3 w-100" onClick={validarCampoExtra} disabled={!respostaCampo}>
                Confirmar
              </button>
            </>
          )}

          {/* Etapa 4 - Senha */}
          {etapa === 4 && (
            <>
              <label>Senha:</label>
              <input
                type="password"
                className="form-control"
                value={senha}
                onChange={(e) => setSenha(e.target.value)}
              />
              <button
                className="btn btn-primary mt-3 w-100"
                onClick={salvarSenha}
                disabled={!senha || senha.length < 6}
              >
                Criar Usuário
              </button>
            </>
          )}
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default CriarUsuario;
